import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import "./Categories.css";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function Categories() {
  const categoriesSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 8,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 8,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
    ],
  };

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseURL = "https://karstar.in/";
  const scrollContainerRef = useRef(null);
  useEffect(() => {
    getCategories();
  }, []);

  const scrollCategories = (direction) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const scrollAmount = container.clientWidth * 0.8;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/api/client_api/productCategories/index.php`
      );
      setCategories(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const generateSlug = (name) => {
    return name.replace(/ /g, "-").replace(/[^\w-]+/g, "");
  };

  return (
    <div>
      <section className="categoriesView">
        <Container>
          <Row className="mt-3">
            <Col>
              {loading ? (
                <>
                  <div className="d-lg-block d-none d-md-block">
                    <div className="categories-scroll-container">
                      {Array.from({ length: 10 }).map((_, index) => (
                        <div className="category-item" key={index}>
                          <Skeleton
                            circle
                            width={130}
                            height={130}
                            containerClassName="me-2"
                            style={{ aspectRatio: "1/1" }}
                          />
                          <Skeleton width={130} />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-sm-block d-md-none d-lg-none">
                    <div className="categories-scroll-container">
                      {Array.from({ length: 10 }).map((_, index) => (
                        <div className="category-item" key={index}>
                          <Skeleton
                            circle
                            width={75}
                            height={75}
                            containerClassName="me-2"
                            style={{ aspectRatio: "1/1" }}
                          />
                          <Skeleton width={75} />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <div className="categories-scroll-wrapper">
                  <button
                    type="button"
                    className="categories-toggle-arrow categories-toggle-prev"
                    onClick={() => scrollCategories("left")}
                    aria-label="Scroll categories left"
                  >
                    <FaChevronLeft />
                  </button>
                  <div
                    className="categories-scroll-container"
                    ref={scrollContainerRef}
                  >
                  {categories
                    .slice() // Create a shallow copy of the array
                    .sort((a, b) => {
                      const aOrder = a.sort_order !== undefined && a.sort_order !== null && a.sort_order !== "" ? Number(a.sort_order) : null;
                      const bOrder = b.sort_order !== undefined && b.sort_order !== null && b.sort_order !== "" ? Number(b.sort_order) : null;

                      if (aOrder !== null && bOrder !== null) {
                        if (aOrder !== bOrder) return aOrder - bOrder;
                      } else if (aOrder !== null) {
                        return -1;
                      } else if (bOrder !== null) {
                        return 1;
                      }

                      const priority = [
                        "All Products",
                        "Instant Geysers",
                        "Portable Washing Machine",
                        "Semi Automatic washing Machine",
                        "High Pressure Washers",
                        "Vaccum Cleaners",
                        "Water Pumps",
                        "Mixers and Wet Grinders",
                        "Gas Stoves",
                        "Chimneys",
                        "Air coolers",
                        "Shoe Racks",
                        "Korai Mat",
                        "Sofa cum Beds",
                      ];
                      const aPriority = priority.indexOf(a.name);
                      const bPriority = priority.indexOf(b.name);

                      // Prioritize the categories in the priority array
                      if (aPriority !== -1 && bPriority !== -1) {
                        return aPriority - bPriority;
                      }
                      if (aPriority !== -1) return -1; // a has priority
                      if (bPriority !== -1) return 1; // b has priority

                      // Default alphabetical sorting for others
                      return (a.name || "").localeCompare(b.name || "");
                    })
                    .map((category, index) => (
                      <Link
                        key={index}
                        to={`/collections/${category.name}`}
                        state={{ category }}
                        className="text-decoration-none text-black category-item"
                      >
                        <div className="px-1 d-flex justify-content-center align-items-center flex-column">
                          <div className="d-flex justify-content-center align-items-center categoriesContainer">
                            <img
                              src={baseURL + category.image_path}
                              alt={category.name}
                              className="categoriesImage"
                            />
                          </div>
                          <p className="text-center mt-2 categoriesText">
                            {category?.name?.replace(/-/g, " ")}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="categories-toggle-arrow categories-toggle-next"
                    onClick={() => scrollCategories("right")}
                    aria-label="Scroll categories right"
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Categories;
